import { MemberContract } from '@lib/core/models/contract.interface';

export interface ExternalPatientReference {
  partnerId: string;
  partnerName: string;
  patientId: string;
}

export const LILO_PARTNER_ID = '00000000-0000-0000-0000-000000000001';
export const DOBROBUT_PARTNER_ID = '09e6e646-6cbe-446d-b2a7-713c5da47748';

export interface MemberProfileSearch {
  id?: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  fullName?: string;
  phoneNumber?: string;
  phoneCode?: string;
  legalAddress?: string;
  actualAddress?: string;
  email?: string;
  city?: string;
  country?: string;
  gender?: string;
  birthDate?: string;
  doctorId?: string;
  doctorName?: string;
  taxId?: string;
  companyName?: string;
  helsiPatientId?: string;
  status?: MemberStatus;
  flowState?: FlowState;
  hadVisit?: boolean;
  terroristCheckDate?: string;
  isTerrorist?: boolean;
  isTestUser?: boolean;
  isActive?: boolean;
}

export interface MemberProfile {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  fullName: string;
  phoneNumber: string;
  phoneCode: string;
  legalAddress: string;
  actualAddress: string;
  email: string;
  city?: string;
  country?: string;
  gender: string;
  birthDate: string;
  doctorId?: string;
  doctorName?: string;
  contracts: MemberContract[];
  taxId?: string;
  companyName?: string;
  helsiPatientId: string;
  status: MemberStatus;
  flowState: FlowState;
  hadVisit: boolean;
  terroristCheckDate: string;
  isTerrorist: boolean;
  isTestUser: boolean;
  dilaPatientId?: string;
  dobrobutPatientId?: number;
  externalPatientReferences?: ExternalPatientReference[];
  documentsVerifiedAt?: string;
  extraDataGatheredAt?: string;
  active: boolean;
  delegatedProfiles?: MemberShortProfile[];
  // TODO: uncomment and adjust when multi-user recommendations sending will be needed
  // isChecked?: boolean; // only FE param
}

export interface MemberShortProfile {
  id: string;
  userId: string;
  fullName: string;
  birthDate: string;
}

export interface MemberFranchiseItem {
  activeFrom: string;
  activeTo: string;
  contractId: string;
  franchises: {
    [key: string]: string;
  }[];
  packageName: string;
}

export interface FlowState {
  isActive: boolean;
  reasons: BlockedReason[];
  flows: Flows;
}

export interface Flows {
  Contract: ContractFlow;
  Freemium: FreemiumFlow;
}

export enum BlockedReason {
  ByLocation = 'ByLocation',
  ByAge = 'ByAge',
}

export interface ContractFlow {
  flowName: string;
  status: MemberStatus;
  availableStatuses: MemberStatus[];
}

export interface FreemiumFlow {
  flowName: string;
  status: MemberStatus;
  availableStatuses: MemberStatus[];
}

export enum MemberStatus {
  Undefined = 'Undefined',
  Questionary = 'Questionary',
  Blocked = 'Blocked',
  DocumentsSharing = 'DocumentsSharing',
  DocumentsExtraData = 'DocumentsExtraData',
  DocumentsSigning1 = 'DocumentsSigning1',
  DocumentsSigning2 = 'DocumentsSigning2',
  Payment = 'Payment',
  Main = 'Main',
  PaymentPending = 'PaymentPending',
  PaymentFailed = 'PaymentFailed',
  SelectPersonalDoctorAddress = 'SelectPersonalDoctorAddress',
  SelectPlan = 'SelectPlan',
  Error = 'Error',
  SelectPersonalDoctorSlot = 'SelectPersonalDoctorSlot',
}
